export const UNSUPPORTED_STATE_MODAL = 'unsupportedStateModal'
export const UNSUPPORTED_INSURANCE_PLAN_MODAL = 'unsupportedInsurancePlanModal'
export const INSURANCE_NOT_FOUND_TEXT = "My insurance isn't listed"
